module.exports = __webpack_public_path__ + "img/setting.56d218e5.svg";